export default __webpack_public_path__ + "static/media/tradingOffer.ffee20c9.svg";